import { EditableText } from '@/components/editor/EditableText';
import { FICHE_COLOR_HEX } from '@/lib/colors';
import type { FicheColor } from '@pharmafiche/schema';

interface MiniHeaderPillProps {
  icon?: string;
  label: string;
  color?: FicheColor;
  dense?: boolean;
  onLabelCommit?: (next: string) => void;
}

/**
 * Small white pill used inside drug cards to head a sub-section
 * (Indications, Posologie, EI/CI…).
 */
export function MiniHeaderPill({
  icon,
  label,
  color,
  dense = false,
  onLabelCommit,
}: MiniHeaderPillProps) {
  const accent = color ? FICHE_COLOR_HEX[color] : '#1f2330';
  const fontPx = dense ? 12 : 13.5;
  const paddingX = dense ? 7 : 9;
  const labelStyle = {
    minWidth: 0,
    overflowWrap: 'anywhere' as const,
    wordBreak: 'break-word' as const,
    hyphens: 'auto' as const,
    lineHeight: 1.1,
  };
  return (
    <div
      className="flex items-center gap-[6px] bg-white border-2 rounded-[10px] font-gloock shadow-ink-sm mt-[10px] mb-1"
      style={{
        color: accent,
        borderColor: accent,
        width: 'fit-content',
        maxWidth: '100%',
        fontSize: fontPx,
        paddingLeft: paddingX,
        paddingRight: paddingX,
        paddingTop: 2,
        paddingBottom: 0,
      }}
    >
      {icon ? <span className="shrink-0">{icon}</span> : null}
      {onLabelCommit ? (
        <EditableText
          value={label}
          plain
          ariaLabel="Étiquette de la sous-section"
          style={labelStyle}
          onCommit={onLabelCommit}
        />
      ) : (
        <span lang="fr" style={labelStyle}>
          {label}
        </span>
      )}
    </div>
  );
}
